import React from 'react';
import PropTypes from 'prop-types';
import './Tiers.scss';
import TiersVariantB from './TiersVariantB';
import { TierOptionsVoucherLink } from '../../tier-options/TierOptionsVoucherLink';
import { SUBSCRIPTION_TIER_B_CHANGE_INFO_SAVOD_1 } from '../../../../constants/Copy';
import { TIER_IDS } from '../../../../constants/Tiers';

const Tiers = ({
	tiers,
	selectedTier,
	isPromo = true,
	onSelectTier,
	proceedUrl,
	onClickProceed,
	toggleSidebar,
	isPromoAllowed,
	isSavodTierSelected,
	setIsSavodTierSelected,
	isSavodExperiment,
}) => {
	return (
		<div className="tiers-control-wrap">
			<TiersVariantB
				tiers={tiers}
				isPromo={isPromo}
				isPromoAllowed={isPromoAllowed}
				selectedTier={selectedTier}
				toggleSidebar={toggleSidebar}
				onSelectTier={onSelectTier}
				proceedUrl={proceedUrl}
				onClickProceed={onClickProceed}
				isSavodTierSelected={isSavodTierSelected}
				setIsSavodTierSelected={setIsSavodTierSelected}
				isSavodExperiment={isSavodExperiment}
			>
				{isSavodExperiment &&
					(selectedTier?.id === TIER_IDS.PREMIUM || selectedTier?.id === TIER_IDS.STANDARD) && (
						<p
							className="tiers-info-savod"
							dangerouslySetInnerHTML={{ __html: SUBSCRIPTION_TIER_B_CHANGE_INFO_SAVOD_1 }} // eslint-disable-line react/no-danger
						/>
					)}
				<TierOptionsVoucherLink />
			</TiersVariantB>
		</div>
	);
};

Tiers.propTypes = {
	tiers: PropTypes.array.isRequired,
	selectedTier: PropTypes.object,
	isPromo: PropTypes.bool,
	onSelectTier: PropTypes.func.isRequired,
	proceedUrl: PropTypes.string,
	onClickProceed: PropTypes.func.isRequired,
	children: PropTypes.node,
};

export default Tiers;
